module.exports = __webpack_public_path__ + "static/moonamar-aceite-de-comino-negro-organico-100-ml-bio-345b1b5b785b84bbbc7a6764d2830b9e.png";